import { useEffect, useRef, useState } from 'react';

const useComponentVisible = <T extends HTMLElement>(
  initialIsVisible: boolean,
) => {
  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);
  const triggerRef = useRef<T>(null);
  const componentRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (triggerRef.current?.contains(event.target as Node)) {
      setIsComponentVisible(!isComponentVisible);
    } else {
      setIsComponentVisible(
        !!componentRef.current?.contains(event.target as Node),
      );
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return {
    triggerRef,
    componentRef,
    isComponentVisible,
    setIsComponentVisible,
  };
};

export default useComponentVisible;
